import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { AuthenticatedUser } from '@/constants'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'InterviewList',
    component: () => import(/* webpackChunkName: "InterviewList" */ '../views/InterviewList/index.vue')
  },
  {
    path: '/interview_detail/:scheduleId',
    name: 'InterviewDetail',
    component: () => import(/* webpackChunkName: "InterviewDetail" */ '../views/InterviewDetail/index.vue')
  },
  {
    path: '/apikey',
    name: 'ApiKey',
    component: () => import(/* webpackChunkName: "ApiKey" */ '../views/ApiKey/index.vue'),
    meta: { requiresAuth: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  // base: '/hr/', // process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.userInfo.userid) {
    await store.dispatch('getUserInfo')
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const curUID = store.state.userInfo.userid + ''
    const isAuthenticated = AuthenticatedUser.includes(curUID)
    if (!isAuthenticated) {
      // 非授权用户
      next({ path: '/' })
      Vue.prototype.$message.error('没有权限，请联系管理员')
    }
  }
  
  // 如果 from 有 jobs_channel 参数，且 to 没有，则添加
  if (from.query.jobs_channel && !to.query.jobs_channel) {
    next({
      path: to.path,
      query: { ...to.query, jobs_channel: from.query.jobs_channel },
      replace: true // 使用 replace 而不是 push，避免在历史记录中留下多余的记录
    })
  } else {
    next()
  }
})

export default router
